module.exports = __webpack_public_path__ + "static/visual_4_1_eg-7deb51710a606cdf5d3666998b17d229.png";